import type { ComputedRef } from 'vue'

import { useCustomersStore } from './store'
import { useCustomersApi } from '../../api/list/list.hook'
import { useCustomerDestroy } from '../../api/list/destroy.hook'

interface ModalDeleteCustomerReturn {
  refIsOpen: ComputedRef<boolean>
  refIsLoading: ComputedRef<boolean>
  closeModal: () => void
  confirmDelete: () => Promise<void>
}

export const useModalDeleteCustomer = (): ModalDeleteCustomerReturn => {
  const store = useCustomersStore()

  const refIsOpen = computed<boolean>(() => store.getDeleteCustomerId !== null)
  const refIsLoading = computed<boolean>(() => store.isDeleting)

  const closeModal = (): void => {
    if (store.isDeleting) return

    store.setDeleteCustomerId(null)
  }

  const confirmDelete = async (): Promise<void> => {
    const customerId = store.getDeleteCustomerId
    if (customerId === null || store.isDeleting) return

    store.setDeleting(true)
    const deleted = await useCustomerDestroy(customerId)
    store.setDeleting(false)
    store.setDeleteCustomerId(null)

    if (deleted) {
      await useCustomersApi()
    }
  }

  return {
    refIsOpen,
    refIsLoading,
    closeModal,
    confirmDelete,
  }
}
